<!-- Per city directory -->
<template>
  <div class="uk-container">

    <h2>Welcome to the {{cityName}} directory!</h2>
    <h4 class="uk-margin-remove">This is a community effort to better discover and find all the great carriers in the Oakland area</h4>
    <h4>Click on a company below to see more information about them</h4>

      <table class="uk-table uk-table-striped uk-table-hover uk-table-divider uk-box-shadow-small">
        <thead>
          <th>Company Name</th>
          <th>Address</th>
          <th>Email</th>
          <th>Phone</th>
        </thead>
        <tbody>
          <tr v-for="company in companiesList" :key="company.id"
              class="uk-box-shadow-hover-small"
              @click="navigateToCompanyDirectoryInfoPage(company.id)"
            >
            <td class="uk-text-left">{{company.name}}</td>
            <td class="uk-text-left">{{fullAddress(company.officeAddress)}}</td>
            <td class="uk-text-left">{{company.email}}</td>
            <td class="uk-text-left">{{company.phoneNumber}}</td>
          </tr>
        </tbody>
      </table>

      <a class="uk-button uk-button-secondary" href="mailto:directory@contrak.us?subject=Add to directory request&body=Hi, my company name is: %0d%0a%0d%0aOur company description is: %0d%0a%0d%0aOur services offered are: %0d%0a%0d%0a">Add my company to the directory</a>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Button from '@/components/core/Button.vue';

import { Company } from '@/utils/company';
import { addressMixin } from '@/utils/address';

import DIRECTORY_FOR_CITY from './gql/DirectoryForCity.gql';

import { getCompanyDirectoryInfoPage } from '../../router/route_utils';

// UIkit.use(Icons);

    // <!-- Button, -->
export default defineComponent({
  name: 'DirectoryCityPage',
  components: {
  },
  props: {
    cityName: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      companiesList: [] as Array<Company>,

      dataLoading: true,
      errorText: null,
    };
  },
  mixins: [addressMixin],
  methods: {
    navigateToCompanyDirectoryInfoPage(companyId: number) {
      (this as any).$router.push(getCompanyDirectoryInfoPage(companyId));
    },
  },
  ...{
    apollo: {
      companiesList: {
        query: DIRECTORY_FOR_CITY,
        variables() {
          return {
            cityName: (this as any).cityName,
          };
        },
        update: (data) => data.directoryForCity.map((dirEntry) => dirEntry.company),
        result(result) {
          const vm = (this as any);

          console.log('[fetching company data] result: ', result);
          vm.dataLoading = false;
          vm.errorText = null;
        },
        error(error) {
          const vm = (this as any);

          vm.dataLoading = false;
          vm.errorText = 'Couldn\'t get directory company info';
          console.error('Fetching data failed: ', error);
        },
      },
    },
  },
});
</script>
